import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ReportingInitResponse,
  ReportingSsrmResponse,
} from '@api-response-types/reporting-ssrm.response';
import { ReportingSsrmQueryDto } from '@api-dto-types/reporting-ssrm-query.dto';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

export interface ReportingInitRequestBody {
  forecastVersionIds: string[];
  additionalTimeSeries?: string[];
  minDate?: string;
  maxDate?: string;
}

@Injectable({ providedIn: 'root' })
export class ReportingHttpClient {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.api.url;

  initReportingData(
    configurationId: string,
    body: ReportingInitRequestBody,
  ): Observable<ReportingInitResponse> {
    return this.http.post<ReportingInitResponse>(
      `${this.baseUrl}/results/of-configuration/${configurationId}/reporting-data/init`,
      body,
    );
  }

  queryRows(
    configurationId: string,
    body: ReportingSsrmQueryDto,
  ): Observable<ReportingSsrmResponse> {
    return this.http.post<ReportingSsrmResponse>(
      `${this.baseUrl}/results/of-configuration/${configurationId}/reporting-data/query`,
      body,
    );
  }

  triggerImport(
    configurationId: string,
    forecastVersionId: string,
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.baseUrl}/results/of-configuration/${configurationId}/reporting-data/import`,
      { forecastVersionId },
    );
  }
}
